<template>
    <div>
        <div class="text-xs-center" v-if="!items">
            <br/><br/>
            <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
            ></v-progress-circular> &nbsp;&nbsp; BUSCANDO CLIENTES
        </div>

        <v-list two-line subheader v-if="items && items.length">

            <template v-for="(item, index) in items">
                <div :key="index">
                    <v-divider :inset="item.inset"  ></v-divider>
                    <v-list-tile avatar >

                        <v-list-tile-avatar>
                            <v-icon v-if="item.status" :class="'green lighten-1 white--text'">network_wifi</v-icon>
                            <v-icon v-else :class="'red lighten-1 white--text'">not_interested</v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.cliente.nome }}</v-list-tile-title>
                            <v-list-tile-sub-title v-if="item.status">ONLINE</v-list-tile-sub-title>
                            <v-list-tile-sub-title v-else>OFFLINE</v-list-tile-sub-title>
                        </v-list-tile-content>

                    </v-list-tile>
                </div>
            </template>

        </v-list>

        <v-container v-if="items && !items.length">
            <v-alert
                    :value="true"
                    color="info"
                    icon="info"
                    outline
            >
                NENHUM CLIENTE NESTA CAIXA
            </v-alert>
        </v-container>

    </div>

</template>

<script>
    import { Caixas } from "../../class/caixas"
    export default {
        name: "ClientesNaCaixa",
        data () {
            return {
                items: null,
                interval: null
            }
        },
        props: {
            id: {
                default: null
            }
        },
        beforeDestroy () {
            clearInterval(this.interval);
        },
        beforeMount () {
            this.load();
            this.interval = setInterval(() => this.load(), 30000);
        },
        methods: {
            load () {
                Caixas
                    .clientes(this.id)
                    .then((json) => {
                        this.items = json.data
                    })
                    .catch(() => {});
            }
        }
    }
</script>

<style scoped>

</style>
